// File: src/Subprogram/Footer.jsx
import React from 'react';
import { Instagram, Linkedin, Monitor } from 'lucide-react';

// --- Custom Icons (Telegram, etc.) ---
const TelegramIcon = ({ size = 24, className }) => (
  <img src="/icon/telegram.svg" width={size} height={size} className={className} alt="Telegram" />
);

const PinterestIcon = ({ size = 24, className }) => (
  <img src="/icon/pinterest.svg" width={size} height={size} className={className} alt="Pinterest" />
);

const EitaaIcon = ({ size = 24, className }) => (
  <img src="/icon/eita.svg" width={size} height={size} className={className} alt="Eitaa" />
);

const BaleIcon = ({ size = 24, className }) => (
  <img src="/icon/bale.svg" width={size} height={size} className={className} alt="Bale" />
);

// --- Social Link Component with Uiverse Animation ---
const SocialLink = ({ href, icon: Icon, colorClass, label }) => (
  <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer"
      className="uiverse-social-container shadow-sm hover:shadow-md"
      title={label}
  >
      <div className="uiverse-social-inner">
          <div className="uiverse-icon-default text-slate-700">
              <Icon size={22} />
          </div>
          <div className={`uiverse-icon-hover ${colorClass}`}>
              {/* کلاس icon-white-filter تصاویر SVG را در حالت هاور کاملا سفید میکند */}
              <Icon size={22} className="icon-white-filter text-white" />
          </div>
      </div>
  </a>
);

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 pt-16 pb-12">
      {/* استایل‌های اختصاصی برای انیمیشن شبکه‌های اجتماعی */}
      <style>{`
        .social-login-icons {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;
          /* افکت انعکاس (رفلکت) پایین آیکون‌ها مشابه نمونه Uiverse */
          -webkit-box-reflect: below 5px linear-gradient(transparent, #0000001a);
          margin-bottom: 25px; /* فضای لازم برای دیده شدن انعکاس */
        }
        .uiverse-social-container {
          width: 50px;
          height: 50px;
          overflow: hidden;
          border-radius: 50%;
          background-color: #f8fafc; /* رنگ پس‌زمینه اولیه */
          border: 1px solid #f1f5f9;
          cursor: pointer;
        }
        .uiverse-social-inner {
          display: flex;
          flex-direction: column;
          /* تایمینگ فانکشن دقیق استخراج شده از کدهای شما برای حالت پرش ملایم */
          transition: transform 0.4s cubic-bezier(0.46, -0.78, 0.5, 1.56);
        }
        .uiverse-social-container:hover .uiverse-social-inner {
          transform: translateY(-50px); /* حرکت به بالا */
        }
        .uiverse-icon-default, .uiverse-icon-hover {
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: none; /* جلوگیری از تغییر ارتفاع داخل فلکس */
        }
        .icon-white-filter {
          /* تبدیل عکس‌های رنگی/سیاه به سفید خالص */
          filter: brightness(0) invert(1);
        }
      `}</style>

      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
           <div className="col-span-1 md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                  <span className="text-xl font-black text-slate-800">Free3dmax.ir</span>
              </div>
              <p className="text-slate-500 text-sm leading-7 text-justify max-w-sm mb-6">
                  مرجع تخصصی دانلود آبجکت، متریال و صحنه‌های آماده معماری. هدف ما ساده‌سازی فرآیند طراحی برای معماران و طراحان داخلی با ارائه منابع با کیفیت و دسته‌بندی شده است.
              </p>
              
              <h5 id="footer-socials" className="font-bold text-slate-800 mb-4 text-sm">ما را دنبال کنید:</h5>
              
              {/* کانتینر جدید آیکون‌ها */}
              <div className="social-login-icons">
                  <SocialLink href="#" icon={EitaaIcon} colorClass="bg-orange-500" label="ایتا" />
                  <SocialLink href="#" icon={BaleIcon} colorClass="bg-green-500" label="بله" />
                  <SocialLink href="#" icon={TelegramIcon} colorClass="bg-sky-500" label="تلگرام" />
                  <SocialLink href="#" icon={Instagram} colorClass="bg-pink-600" label="اینستاگرام" />
                  <SocialLink href="#" icon={Linkedin} colorClass="bg-blue-700" label="لینکدین" />
                  <SocialLink href="#" icon={PinterestIcon} colorClass="bg-red-600" label="پینترست" />
              </div>
           </div>
  
           <div>
              <h4 className="font-bold text-slate-800 mb-6">دسترسی سریع</h4>
              <ul className="space-y-4 text-sm text-slate-500">
                  <li><a href="#" className="hover:text-blue-600 transition-colors">آبجکت‌های رایگان</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">تکسچرهای PBR</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">صحنه‌های آماده رندر</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">اشتراک ویژه VIP</a></li>
              </ul>
           </div>
  
           <div>
              <h4 className="font-bold text-slate-800 mb-6">پشتیبانی</h4>
              <ul className="space-y-4 text-sm text-slate-500">
                  <li><a href="#" className="hover:text-blue-600 transition-colors">تماس با ما</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">قوانین و مقررات</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">سوالات متداول</a></li>
                  <li><a href="#" className="hover:text-blue-600 transition-colors">گزارش خرابی لینک</a></li>
              </ul>
           </div>
        </div>
  
        <div className="border-t border-slate-100 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-slate-400">© 1403 تمامی حقوق برای وبسایت Free3dmax محفوظ است.</p>
          <div className="flex items-center gap-6 text-xs text-slate-400">
              <div className="flex items-center gap-2">
                  <span>طراحی شده توسط</span>
                  <a href="http://arkaniomran.ir/" target="_blank" rel="noopener noreferrer" className="font-bold text-blue-500 hover:text-blue-600 transition-colors flex items-center gap-1">
                     ارکانی عمران
                     <Monitor size={12} />
                  </a>
              </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;